import {createAction, props} from "@ngrx/store";

export const setIncludePartnersStore = createAction(
  '[includePartnersStore] Set Include Partners Store',
  props<{ value: boolean }>()
);
